import React, { useState } from "react";
import CommonTable from "../../../global/table";
import CommonCardView from "../../../global/cardView";
import NoRecordFound from "../../../global/noRecordFound";
import { getMonthName } from "../../../../utils/functions";
import EnhancedInvoicesCardView from "./enhanced-invoices-card-view";
import CommonDrawer from "../../../global/drawer";
import EnhancedInvoicesDetails from "./enhanced-invoices-details";
import { Button, Badge, Tag } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const EnhancedInvoicesList = ({
    isLoading,
    invoices,
    viewType,
    sortBy,
    sortOrder,
    onSort,
}) => {
    const history = useHistory();
    const [invoiceDetails, setInvoiceDetails] = useState({
        show: false,
        data: null
    });

    const payInvoice = (e, invoiceId) => {
        e.stopPropagation();
        history.push("/paymentInvoice?invoice=" + invoiceId);
    };

    const columns = [
        {
            title: "Invoice Month",
            dataIndex: "invoiceMonth",
            key: "invoiceMonth",
            sortType: "Invoice Month",
            render: (text, record) => (
                <span className="font-semibold text-gray-800">
                    {getMonthName(record.invoiceMonth)}, {record.invoiceYear}
                </span>
            ),
        },
        {
            title: "Leads Imported",
            dataIndex: "totalLeadsImported",
            key: "totalLeadsImported",
            sortType: "Leads Imported",
            render: (text) => (
                <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-xs font-bold border border-blue-100 uppercase tracking-wider">
                    {text}
                </span>
            )
        },
        {
            title: "Lead Price",
            dataIndex: "perLeadPrice",
            key: "perLeadPrice",
            sortType: "Lead Price",
            render: (text) => (
                <span className="font-medium text-gray-700">
                    {text} $
                </span>
            )
        },
        {
            title: "Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            sortType: "Amount",
            render: (text) => (
                <span className="font-bold text-success text-sm">
                    {text} $
                </span>
            )
        },
        {
            title: "Status / Actions",
            dataIndex: "paymentStatus",
            key: "paymentStatus",
            render: (text, record) => (
                record.paymentStatus ? (
                    <Tag color="success" className="px-3 py-1 rounded-full border-none">Paid</Tag>
                ) : (
                    <Button
                        type="primary"
                        size="small"
                        icon={<CreditCardOutlined />}
                        className="!bg-primary"
                        onClick={(e) => payInvoice(e, record._id)}
                    >
                        Pay Now
                    </Button>
                )
            )
        },
    ];

    const data = Array.isArray(invoices) && invoices.length > 0
        ? invoices.map((item, index) => ({
            ...item,
            key: item._id || index,
        }))
        : [];

    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={{ sortType: sortBy === "invoiceMonth" ? "Invoice Month" : sortBy, sortOrder }}
                            setSort={(sortObj) => {
                                const fieldMap = {
                                    "Invoice Month": "invoiceMonth",
                                    "Leads Imported": "totalLeadsImported",
                                    "Lead Price": "perLeadPrice",
                                    "Amount": "totalAmount"
                                };
                                onSort(fieldMap[sortObj.sortType] || sortObj.sortType);
                            }}
                            onRowClick={(record) => setInvoiceDetails({ show: true, data: record })}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedInvoicesCardView
                                    key={record.key}
                                    record={record}
                                    onCardClick={(record) => setInvoiceDetails({ show: true, data: record })}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                !isLoading && <NoRecordFound message="No invoices found." />
            )}

            {invoiceDetails.show && (
                <CommonDrawer
                    open={invoiceDetails.show}
                    setOpen={() => setInvoiceDetails({ show: false, data: null })}
                    title="Invoice Details"
                    width={"1000px"}
                    children={
                        <EnhancedInvoicesDetails
                            invoiceDetail={invoiceDetails.data}
                        />
                    }
                />
            )}
        </>
    );
};

export default EnhancedInvoicesList;
